import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Cookie} from 'ng2-cookies/ng2-cookies';

@Injectable()
export class AdminService {

  constructor(private http: Http) {
  }

  private setHeaders(): Headers {
    const headersConfig = {};
    return new Headers(headersConfig);
  }

  getUsers(page, count, column, order, search): Observable<any> {
    let queryParams = `?page=${page}&size=${count}&sort=${column + ',' + order}`;
    if (search != '') {
      queryParams += '&criteria=' + encodeURI(JSON.stringify({name: search, email: search, company: search, crmMasterId: search}));
    }
    return this.http.get(`${environment.baseURL}${environment.admin}users${queryParams}`)
    // return this.http.get(`${environment.baseURL}${environment.admin}users`)
      .map((res: Response) => {
        return res;
      });
  }

  getConfigurations() {
    return this.http.get(`${environment.baseURL}${environment.admin}configuration`)
      .map((res: Response) => {
        return res;
      });
  }

  updateConfiguration(data) {
    return this.http.post(`${environment.baseURL}${environment.admin}configuration`, data)
      .map((res: Response) => {
        return res;
      });
  }

  isActivatedMigration(): Observable<any> {
    return this.http.get(`${environment.baseURL}${environment.admin}zohomigration/isactivatedmigration`)
    .map((res) => {
      return res.text();
    });
  }

  uploadMasterIdsCSVFile(file): Observable<any> {
    let formData:FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.baseURL}${environment.admin}zohomigration/upload/masterids`, formData, {headers: new Headers({'Accept': 'application/json'})})
    .map((res: Response) => {
      return res;
    });
  }

  uploadEmailsWithNoDealCSVFile(file): Observable<any> {
    let formData:FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.baseURL}${environment.admin}zohomigration/upload/emailsnotdeals`, formData, {headers: new Headers({'Accept': 'application/json'})})
    .map((res: Response) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/admin.service.ts